<template>
	<div id="app">
		<Navigation />
		<main>
			<router-view></router-view>
		</main>
	</div>
</template>

<script>
import Logger from "@/assets/Helper/Logger";
import Navigation from "@/components/Navigation.vue";

import {onMounted} from "vue";
import {useStore} from "vuex";
import {useI18n} from "vue-i18n";

export default {
	name: "app",
	components: {
		Navigation
	},
	setup() {
		const store				= useStore();
		const { locale }	= useI18n({});

		onMounted(() => {
			if (typeof window.diamondStockConfig == 'object') {
				if (typeof window.diamondStockConfig.urlPrafix == 'string') {
					store.dispatch('config/setIntegrationUrlPrafix', window.diamondStockConfig.urlPrafix);
				}

				if (typeof window.diamondStockConfig.country == 'string' && typeof window.diamondStockConfig.language == 'string') {
					store.dispatch('config/setCountry', window.diamondStockConfig.country);
					store.dispatch('config/setLanguage', window.diamondStockConfig.language);

					locale.value = window.diamondStockConfig.language.toLowerCase() + "-" + window.diamondStockConfig.country.toUpperCase()
				}

				if (typeof window.diamondStockConfig.shopLogin === 'object') {
					if (
						(
							(typeof window.diamondStockConfig.shopLogin.shopId === 'number' && window.diamondStockConfig.shopLogin.shopId > 10000) ||
							(typeof window.diamondStockConfig.shopLogin.shopId === 'string' && parseInt(window.diamondStockConfig.shopLogin.shopId) > 10000)
						) &&
						(
							window.diamondStockConfig.shopLogin.isActive === true ||
							window.diamondStockConfig.shopLogin.isActive === "yes"
						)
					) {
						store.dispatch('config/setShopId', parseInt(window.diamondStockConfig.shopLogin.shopId));
						Logger.debug("Shop login is active");
					} else {
						Logger.debug("Shop login is disabled");
					}
				}
			}
		});

		let showInitialMsg = localStorage.getItem('showInitialMsg');
		if ((typeof showInitialMsg === 'string' && showInitialMsg === 'false') || showInitialMsg === false) {
			store.dispatch('status/setInitialMsg', false);
		}

		return {}
	}
}
</script>

<style lang="scss">
	#app {
		/*display: block;
		background-size: 15rem;
		background-repeat: repeat;
		background-image: url( './img/diamonds/db_bg.svg');*/
	}
</style>
